{
  "settings": "Configuraciones",
  "yourDigitalAssistant": "Su asistente digital",
  "getStarted": "Empezar",
  "login": "Iniciar sesión",
  "loggingIn": "Iniciando sesión ...",
  "darkMode": "Modo oscuro",
  "clearHistory": "Limpiar historial",
  "historyCleared": "Historial despejado",
  "changeLanguage": "Idioma",
  "termsAndConditions": "Términos y condiciones",
  "messagePlaceholder": "Escribe tu mensaje aquí ...",
  "messagePlaceholderDisabled": "Escritura deshabilitada ...",
  "feedbackTitle": "Califica tu experiencia",
  "feedbackPlaceholder": "Cuéntanos sobre esto (opcional)",
  "feedbackSend": "Enviar",
  "feedbackClose": "Cerrar",
  "sessionExpired": "Su sesión ha expirado debido a la inactividad.",
  "startNewSession": "Empece una nueva sesión",
  "apiError": "¡Vaya! Algo salió mal. Estamos trabajando para solucionar esto lo antes posible",
  "apiErrorOffline": "No está conectado a Internet.",
  "tryAgain": "Inténtalo de nuevo",
  "startOver": "Comenzar de nuevo",
  "chatEnded": "El chat ha finalizado.",
  "chatEndedThankYou": "¡Gracias por conversar con nosotros!",
  "closeChat": "Cerrar",
  "startNewChat": "Chatear de nuevo",
  "humanTakeoverStarted": "Ahora está siendo transferido al servicio al cliente ...",
  "humanTakeoverQueued": "Esperando para conectarse con un agente",
  "humanTakeoverAnAgent": "Un agente",
  "humanTakeoverAgentEntered": "entró en la conversación",
  "humanTakeoverAgentLogout": "dejado la conversación",
  "humanTakeoverTransfer": "Estás siendo transferido a un nuevo agente",
  "humanTakeoverEnded": "Ahora estás chateando con tu asistente digital",
  "version": "Versión",
  "formIntroText": "Complete el siguiente formulario para comenzar a chatear con nosotros",
  "formFirstName": "Nombre",
  "formLastName": "Apellido",
  "formName": "Nombre",
  "formEmail": "Correo electrónico",
  "formWrongEmail": "Proporcione una dirección de correo electrónico válida",
  "formPhone": "Teléfono",
  "formShipmentId": "ID de envío",
  "formQuestion": "Su pregunta",
  "formAccountNumber": "Número de cuenta (para clientes comerciales)",
  "formAddress": "Habla a",
  "formPostcode": "Código postal",
  "formCity": "Ciudad",
  "formCountry": "País",
  "formSubmitButton": "Iniciar chat",
  "formEmptyFieldError": "No se permite estar vacío",
  "formPhoneNumberValidationError": "No es un número de teléfono válido",
  "formInputIsBiggerThan50": "Debe tener como máximo 50 caracteres",
  "formInputIsBiggerThan100": "Debe tener como máximo 100 caracteres",
  "formInputIsBiggerThan2000": "Debe tener como máximo 2000 caracteres",
  "widgetEventOnline": "Mensaje DA: el usuario está nuevamente en línea.",
  "widgetEventHidden": "Mensaje DA: el widget está oculto.",
  "widgetEventVisible": "Mensaje DA: el widget está visible.",
  "widgetEventVisibleMinimized": "Mensaje DA: el widget es visible, pero minimizado.",
  "widgetEventMinimized": "Mensaje DA: el widget está minimizado.",
  "widgetEventMaximized": "Mensaje DA: el widget está maximizado.",
  "widgetEventSessionExpired": "Mensaje DA: la sesión de widgets expiró.",
  "widgetEventHangupHuman": "Mensaje DA: Usuario finalizando sesión de adquisición humana.",
  "widgetEventUserTyping": "Mensaje DA: El usuario está escribiendo.",
  "fileTooLarge": "Está intentando adjuntar archivos demasiado grandes.",
  "tooManyDiles": "Está intentando adjuntar demasiados archivos.",
  "fileInvalidType": "Está intentando adjuntar tipos de archivo no válidos.",
  "attachmentsDropHere": "Suelta aquí para subir o",
  "attachmentsBrowse": "Búsqueda de archivos",
  "attachmentsExtenstionQuantity": "pdf o imágenes (hasta 10 archivos)",
  "attachmentsSize": "hasta 30 MB",
  "attachmentsFailedUploading": "Carga fallida",
  "attachmentsUploading": "Subiendo ...",
  "minimizeExpandText": "¡Chatea en vivo con nosotros ahora!",
  "popupWidgetNotificationMessage": "¡Has recibido un nuevo mensaje!",
  "tabWidgetNotificationMessage": "¡Nuevo mensaje!",
  "datepickerSendButton": "Enviar"
}
